<script setup>
/* X11 Motion — Platzhalter für die spätere Anbindung der GPS-Trackerdaten.
 *
 * Hier werden bewusst KEINE Beispieldaten angezeigt. Die Akte wird Vereinen
 * gezeigt; erfundene Laufwerte darin wären ein echtes Risiko. Solange auf der
 * X11-Seite nichts zum Abholen bereitsteht, bleibt der Reiter ehrlich leer.
 *
 * Siehe TODO.md, "X11-Motion-Anbindung".
 */
</script>

<template>
  <div class="x11">
    <div class="x11-head">
      <img src="/x11-logo.png" alt="" width="44" height="44" />
      <div>
        <div class="x11-claim">{{ $t('x11.claim') }}</div>
        <div class="x11-sub">{{ $t('x11.subtitle') }}</div>
      </div>
    </div>

    <div class="x11-body">
      <div class="x11-status">{{ $t('x11.noData') }}</div>
      <p class="x11-text">{{ $t('x11.explain') }}</p>
    </div>

    <div class="hint">{{ $t('x11.hint') }}</div>
  </div>
</template>

<style scoped>
.x11 {
  border-radius: 12px;
  overflow: hidden;
  background: #0a0e14;
  border: 1px solid var(--border);
}
.x11-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  background: linear-gradient(90deg, #0a121d, #111c2e);
}
.x11-head img {
  border-radius: 8px;
  flex: none;
}
.x11-claim {
  font-size: 0.75rem;
  color: #5ac8e8;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.x11-sub {
  font-size: 0.82rem;
  color: #aac;
  margin-top: 2px;
}
.x11-body {
  padding: 26px 20px;
  text-align: center;
}
.x11-status {
  font-size: 0.78rem;
  color: var(--muted);
  margin-bottom: 10px;
}
.x11-text {
  font-size: 0.82rem;
  color: var(--dim);
  line-height: 1.6;
  max-width: 400px;
  margin: 0 auto;
}
.hint {
  padding: 0 20px 16px;
  text-align: center;
}
</style>
